module.exports = __webpack_public_path__ + "img/play.b88451dc.svg";